<app-entity-page [closeClicked]="closeClicked" [detailsContentTitle]="getDetailsTitle()"
  [mapContentTitle]="'iaa.general.map' | translate" [loading]="sampleIsLoading">
  <ng-template #detailsContent>
    <plaster-sample-details [selectedSample]="selectedSample" [currentLanguage]="currentLanguage$"
      (navigate)="goToEntity($event.entityId, $event.entityType)"></plaster-sample-details>
  </ng-template>
  <ng-template #mapContent>
    <div class="map-container">
      <app-arcgis-map [shapes]="shapes" [mapControls]="mapControls"></app-arcgis-map>
    </div>
  </ng-template>
  <ng-template #footer>
    <div class="info-container">
      <div class="info-items-container">
        <div class="info-title">{{ 'iaa.app.plasterSample.additionalInformation' | translate }}</div>
        <div class="item-container" *ngIf="hasLicense">
          <button class="info-item" type="button" (click)="goToOtherSamples()">
            {{ 'iaa.app.plasterSample.otherSamplesInExcavation' | translate }}
          </button>
        </div>
      </div>
    </div>
  </ng-template>
</app-entity-page>
